import React from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { resourceShape } from './videoShape';
import { NewTabLink } from './TextLinks';

/**
 * A video's companion resource: icon tile, title, description and an "Open"
 * link that opens in a new tab.
 */
ResourceCard.propTypes = {
  resource: resourceShape.isRequired
};

export default function ResourceCard(props) {
  const { resource } = props;
  const { t } = useTranslation();
  const name = resource.title || resource.url;

  return (
    <div className="w-full bg-white border border-cs-gray-100 rounded-[15px] p-2.5 grid grid-cols-[72px_minmax(0,1fr)] md:grid-cols-[72px_minmax(0,1fr)_auto] gap-x-2">
      <div
        className="col-start-1 row-start-1 self-start size-[72px] rounded-[10px] bg-cs-blue-50 flex items-center justify-center"
        aria-hidden="true"
      >
        <DocumentTextIcon className="size-8 text-cs-blue-400" />
      </div>

      <div className="col-start-2 row-start-1 flex flex-col gap-3 pt-2 pl-1 min-w-0 text-cs-gray-700">
        <p className="!mb-0 font-semibold text-[17px] leading-6 break-words">{name}</p>
        {resource.description && (
          <p className="font-normal text-[15px] leading-[1.2]">{resource.description}</p>
        )}
      </div>

      <div className="col-span-2 row-start-2 mt-2 md:mt-0 md:col-span-1 md:col-start-3 md:row-start-1 self-end justify-self-end">
        <NewTabLink
          href={resource.url}
          label={t('home_videos.dialog.resource_open')}
          ariaLabel={t('home_videos.dialog.resource_open_label', { title: name })}
        />
      </div>
    </div>
  );
}
